import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';
import { get } from '@/lib/service/storage';

export declare namespace Member {
    interface Level {
        id: number
        name: string
        participation_count_limit: number
        invite_count_limit: number
        description: string
        image: string
        welfare: Array<Welfare>
    }
    interface MonitorLevel extends Level {
        leadership_count_limit: number
        team_member_limit: number
    }
    interface Welfare {
        id: number
        type: "monitor" | "user",
        name: string
        image: string
        description: string
        value: string
    }
    interface CurrentLevel {
        // type: "monitor" | "user",
        // level_id: number
        // participation_count: number
        // invite_count: number
        // leadership_count: number
        // team_member: number
        id: number
        name: string
        leadership_count: number
        team_member: number
        next_leadership_diff: number
        next_member_diff: number
    }
    interface MonitorCurrentLevel {
        id: number
        name: string
        participation_count: number
        invite_count: number
        next_participation_diff: number
        next_inviet_diff: number
    }
}

export interface MemberState {
    userLevel: Array<Member.Level>
    monitorLevel: Array<Member.MonitorLevel>
    welfare: Array<Member.Welfare>
    current: Member.CurrentLevel | null
    monitorCurrent: Member.MonitorCurrentLevel | null
}

export const member: Module<MemberState, RootState> = {
    namespaced: true,
    state: {
        userLevel: [],
        monitorLevel: [],
        welfare: [],
        current: null,
        monitorCurrent: null
    },
    mutations: {
        setUserLevel(state, userLevel) {
            state.userLevel = userLevel;
        },
        setMonitorLevel(state, monitorLevel) {
            state.monitorLevel = monitorLevel;
        },
        setWelfare(state, welfare) {
            state.welfare = welfare;
        },
        setCurrent(state, current) {
            state.current = current;
        },
        setMonitor(state, current) {
            state.monitorCurrent = current;
        },
    },
    actions: {
        async getUserLevel(context) {
            const response = await Vue.axios.get('/api/v1/level/user_level');
            const rdata = response.data;
            if (rdata.status === 0) {
                context.commit('setUserLevel', rdata.data);
            }
            return rdata;
        },
        async getMonitorLevel(context) {
            const response = await Vue.axios.get('/api/v1/level/monitor_level');
            const rdata = response.data;
            if (rdata.status === 0) {
                context.commit('setMonitorLevel', rdata.data);
            }
            return rdata;
        },
        async getWelfare(context, {
            type, levelId
        }) {
            const response = await Vue.axios.get('/api/v1/level/welfare', {
                params: {
                    type,
                    id: levelId
                }
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                context.commit('setWelfare', rdata.data);
            }
            return rdata;
        },
        async getCurrent(context) {
            const response = await Vue.axios.get('/api/v1/level/current/user');
            const rdata = response.data;
            if (rdata.status === 0) {
                context.commit('setCurrent', rdata.data);
            }
            return rdata;
        },
        async getMonitor(context) {
            const response = await Vue.axios.get('/api/v1/level/current/monitor');
            const rdata = response.data;
            if (rdata.status === 0) {
                context.commit('setMonitor', rdata.data);
            }
            return rdata;
        },
    },
};
